// EXPERIMENTAL - seed data for Authors (background thread will use the 'published_at" value to determine if new data
// needs to be retrieved from the server
import authorData from "@/data/authors.json";
import courseData from "@/data/courses.json";
import productData from "@/data/products.json";

import type { Author, Course, Product } from "@tmi/types/entities";
import { Authors, Courses, Products } from "@tmi/types/api/content-models";
import { ApiFetchResponse } from "@tmi/types/api/fetch";
import { mapAuthorApiResponseToAuthorCatalog } from "@/services/data/sync/author-sync-coordinator";
import { mapCourseApiResponseToCourseCatalog } from "@/services/data/sync/courses-sync-coordinator";

export function authorSeedData(): Author[] {
    let allAuthors: Author[] = [];
    const seed = authorData as ApiFetchResponse< Authors >;
    if ( seed?.data.authorCatalog?.authors ) {
        allAuthors = mapAuthorApiResponseToAuthorCatalog( seed );
    }

    return allAuthors;
}

export function courseSeedData(): Course[] {
    let allCourses: Course[] = [];
    const seed = courseData as ApiFetchResponse< Courses >;
    if ( seed?.data.coursesCatalog?.courses ) {
        allCourses = mapCourseApiResponseToCourseCatalog( seed?.data.coursesCatalog?.courses );
    }

    return allCourses;
}

export function productSeedData(): Product[] {
    let allProducts: Product[] = [];
    const seed = productData as ApiFetchResponse< Products >;
    if ( seed?.data.productCatalog?.products ) {
        allProducts = [ ...( seed.data.productCatalog.products
                .sort( ( prod1: Product, prod2: Product ): number =>
                    ( prod1.name.toLowerCase() > prod2.name.toLowerCase() ) ? 1 :
                        ( ( prod1.name.toLowerCase() < prod2.name.toLowerCase() ) ? -1 : 0 ) )
        ) ];
    }

    return allProducts;
}
